import { forwardRef as k } from "react";
import { useThemeUI as w, get as y, Button as B } from "theme-ui";
import { spinnerContainer as v } from "./styles.js";
import { useVariants as L } from "../../lib/css/css-hooks.js";
import "../../lib/css/match-media-context.js";
import "@theme-ui/css";
import { jsx as n, jsxs as p } from "theme-ui/jsx-runtime";
import { UIKitLink as g } from "../UIKitLink/UIKitLink.js";
import { Spinner as j } from "../Spinner/Spinner.js";
import { Stack as E } from "../Stack/Stack.js";
import { CenteredBox as T } from "../CenteredBox/CenteredBox.js";
import "@material-bank/ds-utils";
import { Text as D } from "../Typography/Text.js";
import { Skeleton as G } from "../Skeleton/Skeleton.js";
const P = k((s, c) => {
  const {
    variant: i = "primary",
    size: e = "lg",
    children: a,
    startIcon: m,
    endIcon: l,
    loading: o = !1,
    fullWidth: u,
    disabled: h,
    withSpinner: r,
    spinnerSize: b,
    ellipsis: f,
    contentSx: S,
    LinkComponent: x,
    ...d
  } = s, {
    href: z
  } = d, I = x ?? g, {
    theme: t
  } = w(), C = y(t, `buttons.${i === "white" ? "secondary" : i}.&:disabled.color`), W = L({
    variant: t.buttons,
    size: t.buttonSizes,
    ...m && {
      buttonWithStartIconSize: t.buttonWithStartIconSizes
    },
    ...l && {
      buttonWithEndIconSize: t.buttonWithEndIconSizes
    }
  });
  return /* @__PURE__ */ n(G, {
    enabled: o && !r,
    applyToDisabled: !0,
    asChild: !0,
    children: /* @__PURE__ */ p(B, {
      ref: c,
      as: z ? I : "button",
      disabled: h || o,
      ...d,
      sx: {
        ...W({
          variant: i,
          size: e,
          buttonWithStartIconSize: e,
          buttonWithEndIconSize: e
        }),
        ...u && {
          width: "100%"
        },
        ...s.sx
      },
      variant: null,
      children: [o && r && /* @__PURE__ */ n(T, {
        sx: v,
        children: /* @__PURE__ */ n(j, {
          color: C,
          size: b
        })
      }), /* @__PURE__ */ p(E, {
        direction: "row",
        sx: {
          columnGap: 1,
          flexGrow: 1,
          justifyContent: "center",
          ...o && r && {
            visibility: "hidden"
          },
          ...S
        },
        children: [m, f ? /* @__PURE__ */ n(D, {
          sx: {
            fontSize: "inherit"
          },
          ellipsis: !0,
          children: a
        }) : a, l]
      })]
    })
  });
});
P.displayName = "Button";
export {
  P as Button
};
